// Keeps the quick-add drawer's bar in step with the chosen variant.
// The drawer's markup is injected as HTML, where inline scripts never run, so this is a custom
// element: it upgrades as soon as the drawer content lands in the page.
class QuickAddBarDetails extends HTMLElement {
  connectedCallback() {
    this.value = this.querySelector('[data-option-value]');
    if (!this.value) return;

    this.onVariantChange = (event) => {
      const variant = event.detail?.variant;
      if (!variant) return;

      this.value.textContent = variant.option1;
    };

    document.addEventListener('change:variant', this.onVariantChange);
  }

  disconnectedCallback() {
    if (this.onVariantChange) document.removeEventListener('change:variant', this.onVariantChange);
  }
}

if (!customElements.get('quick-add-bar-details')) {
  customElements.define('quick-add-bar-details', QuickAddBarDetails);
}
